import { colors, sizes } from "assets/constants";
import React, { useEffect, useState } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

import Icon from "components/Icon";
import Text from "components/Text";

export default function RadioButtonGroup(props: RadioButtonGroupT) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const { data, value, selectedItem, disabled } = props;

  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <View style={styles.container}>
      {data.map((item, key) => {
        return (
          <TouchableOpacity
            disabled={disabled}
            key={String(key)}
            style={styles.item}
            onPress={() => {
              selectedItem && selectedItem(item);
              setSelectedValue(item);
            }}
          >
            <Icon
              size={18}
              name={selectedValue?.id === item.id ? "check-circle" : "circle"}
              color={selectedValue?.id === item.id ? color : colors.iconColor}
            />
            <Text
              weight="bold"
              style={{ bottom: 1 }}
              color={selectedValue?.id === item.id ? color : colors.iconColor}
            >
              {" "}
              {item.title}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    width: "100%",
    borderRadius: sizes.radius.md,
  },

  item: {
    paddingLeft: sizes.space,
    alignItems: "center",
    flexDirection: "row-reverse",
    marginHorizontal: 20,
  },
});
